export const PUSHABLE_CONFIG_KEYS = [
  'address-allow-default-display',
  'address-hide-exempt-al',
  'address-hide-exempt-pm',
  'address-remove-after-event',
  'allow-ad-hoc-reporting',
  'allow-backup-sessions',
  'allow-cico',
  'allow-general-role-applications',
  'allow-individual-shift-times',
  'allow-limited-ad-hoc-reporting',
  'allow-multi-program-application',
  'allow-multiple-cico',
  'allow-roster-comments',
  'allow-unavailability-and-leave',
  'allow-volunteer-activity-cancellation',
  'application-activity-auto-to-application',
  'application-activity-auto-to-team',
  'application-activity-auto-to-waitlist',
  'application-apply-role',
  'application-availability-complex',
  'application-availability-simple',
  'application-enrol-activity',
  'automate-application-validation',
  'bulletin-allow-comment',
  'bulletin-allow-manager-action',
  'enforce-mfa-admin',
  'enforce-mfa-al',
  'enforce-mfa-pm',
  'enforce-mfa-vol',
  'light-touch-reports',
  'notification-application-created',
  'operations-allow-roster-session-visibility',
  'operations-assigned-rostering-view',
  'operations-calendar-invites-enabled',
  'prevent-volunteer-availability-submission',
  'prevent-volunteer-reports',
  'resources-grid-view',
  'see-rostered-dates-only',
  'session-report-visibility',
  'show-capacity-status',
  'task-item-program-visibility',
];
